/**
 * Created by OLD on 20/08/2015.
 */
define('graphicalRequestAllInOneShowView',[
  'module',
  'marionette',
  'underscore',
  'app',
  'settings',
  'stateMessages',
  'dateUtils',
  'jqgridView',
  'template!graphicalRequestAllInOneViewTpl',
  'notificationCenter',
  'bootbox',
  'tariffScaleData',
  'graphicalRequestAllInOneTariffScaleView',
  'ticketStates',
  'datePickerPopoverMixin',
  'rolesMixin',
  'zoomFullScreenBehavior'
], function(
  module,
  Marionette,
  _,
  App,
  Settings,
  StateMessages,
  dateConverter,
  JqGridView,
  viewTpl,
  NotificationCenter,
  bootbox,
  tariffScales,
  TariffScaleView,
  ticketStates,
  datePickerPopoverMixin,
  RolesMixin,
  ZoomFullScreenBehavior
) {
  'use strict';

  var GraphicalRequestAllInOneTableView = JqGridView.extend({
    GRID_MIN_WIDTH: 850,
    template: viewTpl,
    filtersName: 'graphicalRequestAllinOneFilters',

    triggers: {
      'click @ui.addNew' : 'onCreateNew',
      'click @ui.creditBtn' : 'onNavigateToCredit'
    },

    behaviors: {
      StateMessages: {
        behaviorClass: StateMessages
      },
      ZoomFullScreenBehavior: {
        behaviorClass: ZoomFullScreenBehavior,
        target: '.attach-img'
      }
    },

    ui: function() {
      return _.extend({
        jqGrid: '#jq-grid-vector',
        jqGridPager: '#jq-grid-pager-vector',
        addNew: '.new-vector-button',
        tariffScaleSelect: 'select[data-ticket-cid]',
        urgencyCheckbox: 'input[type=checkbox]',
        creditBtn : '.credit-info-block'
      }, this.gridUi);
    },

    events: function() {
      return _.extend({
        'change @ui.tariffScaleSelect': 'onTariffScaleChange',
        'change @ui.urgencyCheckbox': 'onChangeUrgency'
      }, this.gridEvents);
    },

    serializeData: function() {
      return {
        vectorizator: Settings.get('cAccountRoles')[RolesMixin.VECTORIZATOR],
        balance: this.options.balance
      };
    },

    onShow: function() {
      NotificationCenter.getInstance().addListener(this, NotificationCenter.events.NEW_VECTORISATION_TICKET, this.onNewTicket);
    },

    onNewTicket: function(response) {
      this.updatePagination('reloadGrid');
      NotificationCenter.getInstance().processNotification(response);
    },

    onTariffScaleChange: function(e) {
      var $target = $(e.currentTarget);
      this.trigger('tickets:update:tariffScale', $target.data('ticket-cid'), $target.find(':selected').val());
    },

    onChangeUrgency: function(e) {
      var that = this,
        $input = $(e.currentTarget),
        ticketID = $input.data('ticket-cid'),
        checked = $input.is(':checked');
      if(!checked) {
        // Don't need confirmation if unchecking.
        that.trigger('ticket:update:urgency', ticketID, checked);
        return;
      }
      bootbox.confirm(
        _.i18n('warning.updateTicketUrgency'),
        function (result) {
          if (result) {
            that.trigger('ticket:update:urgency', ticketID, checked);
          } else {
            $input.prop('checked', !checked);
          }
        }
      );
    },

    gridOptions: function(data) {
      var that = this,
        defaultsOptions, options;

      this.sidx = 'userTimestamp.modDate';
      this.sord = 'desc';
      defaultsOptions = this.gridInitOptions(data);
      options = {
        colModel: [
          {
            label: '',
            name: 'secId',
            key: true,
            hidden: true
          }, {
            label: '<i class="mdi-maps-local-post-office icon"></i>',
            name: 'messages',
            classes: 'tickets',
            formatter: this.messageFormatter,
            search: false,
            sortable: false,
            index: 'unreadMessages',
            width: 45
          }, {
            label: _.i18n('common.type'),
            name: 'type',
            classes: 'tickets-type',
            formatter: this.typeFormatter,
            search: true,
            stype:'select',
            searchrules: {type: true},
            searchoptions: {
              value: that.graphicalTypes
            },
            index: 'type',
            width: 75  
          }, {
            label: _.i18n('vectorization.tickets.column.attachment'),
            name: 'attachment',
            align: 'left',
            classes: 'tickets-link image-cell complexity-colored',
            formatter: this.attachFormatter,
            search: false,
            sortable: false,
            width: 75
          }, {
            label: _.i18n('common.subject'),
            name: 'name',
            classes: 'tickets-link',
            formatter:  this.defaultFormatter,
            search: true,
            index: 'name'
          }, {
            label: _.i18n('common.date.create'),
            name: 'date',
            classes: 'tickets-link',
            formatter:  this.dateFormatter,
            search: true,
            index: 'date',
            sorttype: 'date', 
            searchrules: {date: true},
            searchoptions: {
              dataInit: datePickerPopoverMixin.jqGridDataInit
            },
            width: 130
          }, {
            label: _.i18n('common.date.mod'),
            name: 'modDate',
            classes: 'tickets-link',
            formatter: this.dateFormatter,
            search: true,
            index: 'modDate',
            sorttype: 'date', 
            searchrules: {date: true},
            searchoptions: {
              dataInit: datePickerPopoverMixin.jqGridDataInit
            },
            width: 130
          }, {
            label: _.i18n('vectorization.tickets.requester'),
            name: 'requester',
            index: 'requester',
            classes: 'tickets-link',
            formatter:  this.defaultFormatter,
            search: true,
            width: 175
          }, {
            label: _.i18n('common.urgency'),
            name: 'urgent',
            classes: 'tickets-link cell-urgency',
            formatter: this.urgencyFormatter,
            search: true,
            index: 'urgent',
            stype:'select',
            searchrules: {select: true},
            searchoptions: {
              value: that.typeStatuses
            },
            width: 100
          }, {
            label: _.i18n('common.status'),
            name: 'ticketState',
            classes: 'tickets-link',
            formatter: this.stateFormatter,
            search: true,
            index: 'ticketState',
            stype:'select', 
            searchrules: {select: true},
            searchoptions: {
              value: that.stateStatuses
            },
            width: 100
          }, {
            label: _.i18n('vectorization.tariffScale'),
            name: 'tariffScale',
            formatter: this.tariffScaleFormatter,
            search: true,
            index: 'tariffScale',
            stype: 'select',
            searchrules: {select: true},
            searchoptions: {
              value: that.tariffScales
            },
            cellattr: function() {
              return 'title="' + _.i18n('vectorization.tariffScale') + '"';
            },
            width: 85
          }
        ],

        serializeGridData: function(postData) {
          var columnsWithSelect = [
              'ticketState',
              'tariffScale',
              'urgent'
            ];

          _.each(columnsWithSelect, function(select) {
            if (postData[select] === that.selectDefault) {
              delete postData[select];
            }
          });

          if (postData.date) {
            postData.dateFrom = datePickerPopoverMixin.parseDateFrom(postData.date);
            postData.dateTo = datePickerPopoverMixin.parseDateTo(postData.date);
          } else {
            delete postData.dateFrom;
            delete postData.dateTo;
            delete postData.date;
          }

          if (postData.modDate) {
            postData.modDateFrom = datePickerPopoverMixin.parseDateFrom(postData.modDate);
            postData.modDateTo = datePickerPopoverMixin.parseDateTo(postData.modDate);
          } else {
            delete postData.modDateFrom;
            delete postData.modDateTo;
          }

          if (postData.sidx === 'date') {
            postData.sidx = 'userTimestamp.creatDate';
          }

          if (postData.sidx === 'modDate') {
            postData.sidx = 'userTimestamp.modDate';
          }

          defaultsOptions.serializeGridData.apply(this, arguments);

          return postData;
        },

        onSelectRow: function (rowid, bool, e) {
          var cellUrgency = that.$('.cell-urgency'),
          cellPreview = that.$('.image-cell');

          if (e.type === 'click' && cellUrgency.has(e.target).length === 0 && 
            cellPreview.has(e.target).length === 0) {
            that.trigger('tickets:show', rowid);
          }
        }
      };
      options = _.defaults(options, defaultsOptions);

      return options;
    },

    getSelectValues: function() {
      var that = this,
        typeStatuses = [
          {
            send: 'false',
            display: _.i18n('common.state.noturgency')
          }, {
            send: 'true',
            display: _.i18n('common.state.urgent')
          }
        ],
        graphicalTypes = [
          {
            send: 'vectorization',
            display: _.i18n('vectorization')
          },
          {
            send: 'conversion',
            display: _.i18n('conversion.title')
          },
          {
            send: 'remove_background',
            display: _.i18n('backRemove.title')
          },
           {
            send: 'colorization',
            display: _.i18n('colorization.title')
          }
        ],
        stateStatuses = [
          {
            send: ticketStates.OPEN.state,
            display: ticketStates.OPEN.label
          }, {
            send: ticketStates.PROGRESS.state,
            display: ticketStates.PROGRESS.label
          }, {
            send: ticketStates.REVIEW.state,
            display: ticketStates.REVIEW.label
          }, {
            send: ticketStates.PENDING.state,
            display: ticketStates.PENDING.label
          }, {
            send: ticketStates.DONE.state,
            display: ticketStates.DONE.label
          }, {
            send: ticketStates.CANCELED.state,
            display: ticketStates.CANCELED.label
          }, {
            send: ticketStates.CLOSE.state,
            display: ticketStates.CLOSE.label
          }
        ];

      this.typeStatuses = this.selectDefault + ':' + this.selectDefault;
      _.each(typeStatuses, function(status) {
        that.typeStatuses += ';' + status.send + ':' + status.display;
      });

      this.stateStatuses = this.selectDefault + ':' + this.selectDefault;
      _.each(stateStatuses, function(status) {
        that.stateStatuses += ';' + status.send + ':' + status.display;
      });

      this.tariffScales = this.selectDefault + ':' + this.selectDefault;
      _.each(tariffScales, function(tariffScale) {
        that.tariffScales += ';' + tariffScale.send + ':' + tariffScale.label;
      });

      this.selectValue = {
        ticketState: stateStatuses[0].display,
        type: typeStatuses[0].display,
        tariffScale: tariffScales[0].display
      };
      this.graphicalTypes = '' + ':' + this.selectDefault;
      _.each(graphicalTypes, function(status) {
        that.graphicalTypes += ';' + status.send + ':' + status.display;
      });
    },

    onGridFilterChange: function(e) {
      var that = this,
        filters = {},
        value;

      this.triggerClear(e);

      that.$('#gs_date').popover('hide');
      that.$('#gs_modDate').popover('hide');
      _.each(this.colModel, function(column) {
        if (column.search) {
          if (column.stype === 'select') {
            value = that.$('select[name="' + column.index + '"]').val();
            filters[column.index] = value === that.selectDefault ? '' : value;
          } else if (column.sorttype === 'date') {
            value = that.$('input[name="' + column.index + '"]').val();
            if (column.index === 'date' && value) {
              filters.dateFrom = datePickerPopoverMixin.parseDateFrom(value);
              filters.dateTo = datePickerPopoverMixin.parseDateTo(value);
            } else if (column.index === 'modDate' && value) {
              filters.modDateFrom = datePickerPopoverMixin.parseDateFrom(value);
              filters.modDateTo = datePickerPopoverMixin.parseDateTo(value);
            }
          } else {
            value = that.$('input[name="' + column.index + '"]').val();
            filters[column.index] = value;
          }
        }
      });

      this.filters = filters;
      this.filterChange = true;
      this.updatePagination();
    },

    urgencyFormatter: function(cellvalue, options, rowObj) {
      var checked = cellvalue ? 'checked' : '',
        disabled = ticketStates[rowObj.ticketState] === ticketStates.CLOSE ? 'disabled' : '',
        htmlEl = '<div class="form-group checkbox-group">' + 
          '<div class="checkbox checkbox-primary ' + disabled + '"><label>' +
          '<input type="checkbox" data-ticket-cid="' + options.rowId +
          '" class="js-ticket-urgent" ' + checked + ' ' + disabled +
          '></label></div></div>';
      return htmlEl;
    },

    stateFormatter: function(cellvalue) {
      var ticketState = ticketStates[cellvalue],
        state = ticketState ? ticketState.label : '';

      return '<span>' + state + '</span>';
    },

    typeFormatter: function(cellvalue) {
      var $class = '';
      if (cellvalue === 'vectorization') {
        $class = 'mdi-image-grain';
      } else if (cellvalue === 'conversion') {
        $class = 'mdi-av-repeat';
      } else if (cellvalue === 'remove_background') {
        $class = 'mdi-content-content-cut';
      } else if (cellvalue === 'colorization') {
        $class = 'mdi-image-palette';
      }

      return '<span><i class="' + $class + '"></i></span>';
    },

    messageFormatter: function(cellvalue, options, rowObject) {
      var currentUserPid = Settings.get('currentUser' ),
        unReadMessageCounter = 0, messages,
        founded = false;
      _.each( rowObject.messages, function(message, index) {
        if (index > 1) {
          founded = _.some(message.userpidReaders,function(userpidReader) {
            return userpidReader.secId === currentUserPid.secId;
          });

          if (!founded && (Settings.get('cAccountRoles')[RolesMixin.VECTORIZATOR] && message.direction === 'from' ||
              !Settings.get('cAccountRoles')[RolesMixin.VECTORIZATOR] && message.direction === 'to') &&
              ticketStates[rowObject.ticketState] !== ticketStates.CLOSE) {
            unReadMessageCounter++;
          }
        }
      });
      if (unReadMessageCounter > 0) {
        messages = '<span class="badge action-bg up count tickets">' +
          unReadMessageCounter + '</span>';
        return '<i class="i i-chat3 tickets"></i>' + messages;
      } else {
        return '';
      }

    },

    attachFormatter: function(cellvalue, options, rowObject) {
      var result,
          fileLink, fileName = '', 
          originalFile = '',
          attachment = rowObject.messages[0].attachements[0];

      if (attachment) {
        fileLink = Settings.url('base', attachment.fileLink);
        originalFile = Settings.url('base', attachment.downloadLink.substring(0, attachment.downloadLink.indexOf('?cmds=on')));
        fileName = attachment.fileName;
      } else {
        fileLink = Settings.get('notFoundImage');
      }

      result = '<img class="jq-picture attach-img js-image-cell" ' +
          '" data-link="' + fileLink + '" data-name="' + fileName + '" src="' + fileLink + '">';

      return result;
    },

    dateFormatter: function(cellvalue) {
      var date = dateConverter.toDateFormatString(cellvalue),
        time = dateConverter.toTimeFormatString(cellvalue);

      return '<span class="cell-date">' + date + ' ' + time + '</span>';
    },

    tariffScaleFormatter: function(cellvalue, options, rowObject) {
      if(Settings.get('cAccountRoles')[RolesMixin.VECTORIZATOR] &&
          ticketStates[rowObject.ticketState] !== ticketStates.CLOSE &&
          ticketStates[rowObject.ticketState] !== ticketStates.CANCELED) {
        var view = new TariffScaleView({
          tariffScale: cellvalue,
          cid: options.rowId
        });
        view.render();
        options.colModel.classes = 'without-tooltip';
        return view.$el.html();
      } else {
        options.colModel.classes = '';
        return '<span>' + cellvalue + '</span>';
      }
    }
  });

  module.exports = GraphicalRequestAllInOneTableView;
});
